import React from "react";
import { Drawer, Space, Button, Typography, Select,Input,Table } from "antd";

const RejectionCommentDrawer = (props) => {
      const columns = [
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: 'Comments',
          dataIndex: 'comment',
          key: 'comment',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
              <Space size="middle">
                <a onClick={()=>{
                    props.editComment(record?.title,record?.comment)
                }}>Edit</a>
                <Button
                type="link"
                 loading={props?.loading && record?.title ==  props?.selectedField}
                 onClick={()=>{
                    props.deleteComment(record?.title)
                }}>{props?.loading && record?.title ==  props?.selectedField ? null:'Delete'}</Button>
              </Space>
            ),
          }
      ];
    const { Title, Text } = Typography
    const { Option } = Select;
    return <Drawer
        title="Reject Profile"
        placement='right'
        width={700}
        maskClosable={false}
        onClose={() => {

        }}
        visible={props.visible}
        extra={
            <Space>
                <Button onClick={() => {
                    props.closeDialog()
                }}>Cancel</Button>
                <Button type="primary" onClick={() => {props?.approveUser(false) }}>
                    Send Objection
                </Button>
            </Space>
        }
    >
        <Title level={5}>Why are you rejecting this profile?</Title>
        <p>Please mention the objection points that are causing profile rejection. The registrant will be notified to remove that objection and resubmit the registration request.</p>

        <div className="Object-list">
            <div className="singleElement">
                <div className="label">
                    <Text type="danger">*</Text>
                    <Text> Select the field you have objection</Text>
                </div>
                <Select placeholder="Please select" options={props?.selected} value={props.selectedField} size="large" onChange={(e)=>{
                    props.selectFields("fields",e)
                }}>
                </Select>

            </div>
            <div className="singleElement">
                <div className="label">
                    <Text> Feedback / Comment</Text>
                </div>
              <Input size="large" placeholder="Please Add Comments" value={props.comment} onChange={(e)=>{
                  props.selectFields("comment",e.target.value)
              }}/>

            </div>
            <div className="singleElement">
               <Button style={{height:'40px'}} type="primary" onClick={()=>{
                   if(props.selectedField != null && props.comment != ''){
                    props.addComment()
                   }
                   
               }}
               loading={props?.loading ==  true && props?.loader == true ? true :false}
               >Add</Button>

            </div>
        </div>

        <Table size="small" dataSource={props?.objectDetails} columns={columns} pagination={false} />
    </Drawer>
}

export default RejectionCommentDrawer